export var Routes;
(function (Routes) {
    Routes["PrequalifiedEror"] = "offer-error";
    Routes["NoHitError"] = "offer-error-extended";
    Routes["ReviewRequiredUploadDocuments"] = "review-required-upload-documents";
    Routes["Root"] = "/";
    Routes["PrequalifiedOffers"] = "1-potential-offers";
    Routes["ReviewDetails"] = "2-review-details";
    Routes["UploadDocuments"] = "3-upload-documents";
    Routes["ExistingLoans"] = "4-existing-loans";
    Routes["WeAreReviewing"] = "5-we-are-reviewing";
    Routes["WeRequiereAdditionalInfo"] = "6-we-require-additional-info";
    Routes["SelectAFinalLoanOffer"] = "7-select-a-final-loan-offer";
    Routes["ConfirmFinalLoanOffer"] = "8-confirm-final-loan-offer";
    Routes["ESign"] = "9-esign";
    Routes["OneLastThing"] = "10-one-last-thing";
    Routes["CheckPresign"] = "11-a-check-presign";
    Routes["DocumentSigning"] = "11-document-signing";
    Routes["BusinessInformation"] = "business-information";
    Routes["CheckingApplication"] = "checking-application";
    Routes["DocumentSigningLanding"] = "document-signing-landing";
    Routes["ErrorOnDocumentSigning"] = "error-on-document-signing";
    Routes["HelloExistingApplication"] = "hello-existing-application";
    Routes["HelloNewApplication"] = "hello-new-application";
    Routes["LoanDetails"] = "loan-details";
    Routes["MyAccount"] = "my-account";
    Routes["MyFinances"] = "my-finances";
    Routes["PagesSwitcher"] = "pages-switcher";
    Routes["PersonalInformation"] = "personal-information";
    Routes["ApplicationError"] = "application-error";
    Routes["GenericError"] = "generic-error";
    Routes["QualifyPartner"] = "qualify-partner";
    Routes["Rejected"] = "learn";
    Routes["ResetPassword"] = "reset-password";
    Routes["ReviewMyApplication"] = "review-my-application";
    Routes["SignUpVerifyAccount"] = "sign-up-verify-account";
    Routes["StartLoan"] = "start-loan";
    Routes["ClaimLoan"] = "claim-loan";
    Routes["DeclinedToSign"] = "11-b-declined-to-sign";
    Routes["ReviewRequired"] = "review-required";
    Routes["GenericErrorNoAuth"] = "generic-error-no-auth";
    Routes["ClaimApplicationError"] = "claim-application-error";
    Routes["ConnectBankAccount"] = "connect-bank-account";
    Routes["ClaimLanding"] = "claim-landing";
    Routes["BeneficialOwners"] = "4-5-beneficial-owners";
})(Routes || (Routes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm91dGVzLmpzeCIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJvdXRlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksTUE0Q1g7QUE1Q0QsV0FBWSxNQUFNO0lBQ2hCLDBDQUFnQyxDQUFBO0lBQ2hDLDZDQUFtQyxDQUFBO0lBQ25DLDRFQUFrRSxDQUFBO0lBQ2xFLG9CQUFVLENBQUE7SUFDVixtREFBeUMsQ0FBQTtJQUN6Qyw0Q0FBa0MsQ0FBQTtJQUNsQyxnREFBc0MsQ0FBQTtJQUN0Qyw0Q0FBa0MsQ0FBQTtJQUNsQywrQ0FBcUMsQ0FBQTtJQUNyQyxtRUFBeUQsQ0FBQTtJQUN6RCwrREFBcUQsQ0FBQTtJQUNyRCw4REFBb0QsQ0FBQTtJQUNwRCwyQkFBaUIsQ0FBQTtJQUNqQiw0Q0FBa0MsQ0FBQTtJQUNsQyw2Q0FBbUMsQ0FBQTtJQUNuQyxpREFBdUMsQ0FBQTtJQUN2QyxzREFBNEMsQ0FBQTtJQUM1QyxzREFBNEMsQ0FBQTtJQUM1Qyw2REFBbUQsQ0FBQTtJQUNuRCw4REFBb0QsQ0FBQTtJQUNwRCxpRUFBdUQsQ0FBQTtJQUN2RCx1REFBNkMsQ0FBQTtJQUM3QyxzQ0FBNEIsQ0FBQTtJQUM1QixrQ0FBd0IsQ0FBQTtJQUN4QixvQ0FBMEIsQ0FBQTtJQUMxQiwwQ0FBZ0MsQ0FBQTtJQUNoQyxzREFBNEMsQ0FBQTtJQUM1QyxnREFBc0MsQ0FBQTtJQUN0Qyx3Q0FBOEIsQ0FBQTtJQUM5Qiw0Q0FBa0MsQ0FBQTtJQUNsQyw0QkFBa0IsQ0FBQTtJQUNsQiwwQ0FBZ0MsQ0FBQTtJQUNoQyx1REFBNkMsQ0FBQTtJQUM3Qyx3REFBOEMsQ0FBQTtJQUM5QyxrQ0FBd0IsQ0FBQTtJQUN4QixrQ0FBd0IsQ0FBQTtJQUN4QixrREFBd0MsQ0FBQTtJQUN4Qyw0Q0FBa0MsQ0FBQTtJQUNsQyxzREFBNEMsQ0FBQTtJQUM1QywyREFBaUQsQ0FBQTtJQUNqRCxxREFBMkMsQ0FBQTtJQUMzQyx3Q0FBOEIsQ0FBQTtJQUM5QixvREFBMEMsQ0FBQTtBQUM1QyxDQUFDLEVBNUNXLE1BQU0sS0FBTixNQUFNLFFBNENqQiJ9